export { TextBlockVariantTwo } from "./text-block-variant-two";
